module.exports = __webpack_public_path__ + "img/duris.7c6eff29.png";